/**
 * 模块显示名单源(B2 §3.2 预置,platformLabel 范式)。
 *
 * B3(2026-07-22)改名落地:「爆款情报」—— 解析是动作,情报是部门(拆解 + 蓝图资产 +
 * 未来榜单/对标统一归口)。改名=改这里 + locales nav.explosiveParse 同一 commit,
 * 全站(工作台部门卡/侧栏/页头)一处生效,不留新旧名混用窗口。
 * module_key(ai_explosive_parse)/ 路由(/ai-explosive)/ RBAC / 计费全不动 ——
 * 这里只管「显示层叫什么」。
 */
// 2026-07-31 卡墙改版:老板批注把卡面能力标签统一成「AI + 做什么」的说法
// (AI海报→AI平面设计 / AI视频→AI视频创作 / AI分身→AI数字分身 / AI记者→AI文案策划)。
// 2026-08-09 命名统一批:ai_kefu/ai_peilian/geo_radar 三条死项删除(无消费方,舱名一律走后端
// catalog / i18n cabin.name.*;这里只剩 tagline 轴)。这四个值是**卡面副标**(DEPT_ENTRIES.tagline 的唯一来源),module_key / 路由 / 计费全不动。
export const MODULE_LABEL: Record<string, string> = {
  ai_poster: "AI平面设计",
  ai_video: "AI视频创作",
  ai_digital_human: "AI数字分身",
  ai_explosive_parse: "爆款情报",
  ai_reporter: "AI文案策划",
};

/** 取模块显示名;未知 key 原样返回(诚实展示,不吞新值)。 */
export function moduleLabel(key: string): string {
  return MODULE_LABEL[key] ?? key;
}
